import { ArticlesDetailsStore, ArticlesDetailsActions } from './types';

export const defaultState: ArticlesDetailsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  relatedArticlesError: null,
  relatedArticlesIsLoading: false,
  relatedArticlesIsLoaded: false,
  article: null,
  relatedArticles: [],
};

const reducer = (
  state: ArticlesDetailsStore = defaultState,
  action: { type: ArticlesDetailsActions; payload?: any }
): ArticlesDetailsStore => {
  const {
    FetchDetailsBegin,
    FetchDetailsError,
    FetchDetailsSuccess,
    FetchRelatedArticlesBegin,
    FetchRelatedArticlesSuccess,
    FetchRelatedArticlesError,
  } = ArticlesDetailsActions;
  switch (action.type) {
    /*
     * Article Details
     */
    case FetchDetailsBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case FetchDetailsError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchDetailsSuccess: {
      const { ...payload } = action.payload;
      return {
        ...state,
        ...payload,
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }

    /*
     * Related Articles
     */
    case FetchRelatedArticlesBegin: {
      return {
        ...state,
        relatedArticlesIsLoading: true,
        relatedArticlesIsLoaded: false,
        relatedArticlesError: null,
      };
    }
    case FetchRelatedArticlesError: {
      return {
        ...state,
        relatedArticlesIsLoading: false,
        relatedArticlesIsLoaded: true,
        relatedArticlesError: action.payload,
      };
    }
    case FetchRelatedArticlesSuccess: {
      return {
        ...state,
        relatedArticles: action.payload,
        relatedArticlesIsLoading: false,
        relatedArticlesIsLoaded: true,
        relatedArticlesError: null,
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
